import React, { useEffect, useState, useRef } from 'react';
import { ArrowRight, ChevronRight, Menu, X } from 'lucide-react';
import { ContactModal } from './ContactModal';
export function Hero() {
  const [isUnlocked, setIsUnlocked] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [sliderPosition, setSliderPosition] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const sliderRef = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const handleUnlock = () => {
    setIsUnlocked(true);
    setTimeout(() => {
      window.open('https://wa.me/573135250384?text=Hola%20Krove%20Latam%2C%20estoy%20interesad%40%20en%20tus%20servicios.', '_blank');
      setIsUnlocked(false);
      setSliderPosition(0);
    }, 500);
  };
  const handleDragStart = (e: React.MouseEvent | React.TouchEvent) => {
    if (isUnlocked) return;
    setIsDragging(true);
    e.preventDefault();
  };
  const handleDragMove = (e: MouseEvent | TouchEvent) => {
    if (!isDragging || isUnlocked || !containerRef.current || !sliderRef.current) return;
    const containerRect = containerRef.current.getBoundingClientRect();
    const sliderWidth = sliderRef.current.offsetWidth;
    const maxDrag = containerRect.width - sliderWidth - 8;
    let clientX = 0;
    if ('touches' in e) {
      clientX = e.touches[0].clientX;
    } else {
      clientX = e.clientX;
    }
    const newPosition = Math.max(0, Math.min(clientX - containerRect.left - sliderWidth / 2, maxDrag));
    setSliderPosition(newPosition);
    if (newPosition >= maxDrag * 0.9) {
      setIsDragging(false);
      handleUnlock();
    }
  };
  const handleDragEnd = () => {
    if (!isUnlocked) {
      setSliderPosition(0);
    }
    setIsDragging(false);
  };
  useEffect(() => {
    if (isDragging) {
      const handleMouseMove = (e: MouseEvent) => handleDragMove(e);
      const handleTouchMove = (e: TouchEvent) => handleDragMove(e);
      const handleMouseUp = () => handleDragEnd();
      const handleTouchEnd = () => handleDragEnd();
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('touchmove', handleTouchMove, {
        passive: false
      });
      document.addEventListener('mouseup', handleMouseUp);
      document.addEventListener('touchend', handleTouchEnd);
      return () => {
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('touchmove', handleTouchMove);
        document.removeEventListener('mouseup', handleMouseUp);
        document.removeEventListener('touchend', handleTouchEnd);
      };
    }
  }, [isDragging]);
  return <section id="inicio" className="relative min-h-screen flex flex-col items-center justify-center pt-24 pb-16 overflow-hidden" data-id="element-100">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-101">
        <img src="https://cdn.magicpatterns.com/uploads/boih7q85NCFbma8Fc2Y4LK/Banner.png" alt="Abstract dark background" className="w-full h-full object-cover opacity-100" data-id="element-102" />
        <div className="absolute inset-0 bg-gradient-to-b from-background/30 via-background/50 to-background" data-id="element-103"></div>

        {/* Subtle gradient meshes */}
        <div className="absolute top-1/4 left-0 w-96 h-96 bg-primary/10 rounded-full blur-[120px] -translate-x-1/2" data-id="element-104"></div>
        <div className="absolute bottom-1/4 right-0 w-96 h-96 bg-accent-start/5 rounded-full blur-[120px] translate-x-1/2" data-id="element-105"></div>
      </div>

      {/* Navigation (Floating) */}
      <nav className="fixed top-0 left-0 right-0 z-50 glass-nav px-4 md:px-6 py-4" data-id="element-106">
        <div className="max-w-7xl mx-auto flex items-center justify-between" data-id="element-107">
          <div className="flex items-center" data-id="element-108">
            <img src="https://cdn.magicpatterns.com/uploads/hdwTRmatKyUZFdT516kJwa/Logo_sin_fondo.png" alt="Krove Latam" className="h-14 md:h-20 lg:h-24 object-contain" data-id="element-109" />
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8 text-sm font-medium text-text-secondary" data-id="element-110">
            <a href="#inicio" className="hover:text-white transition-colors" data-id="element-111">
              Inicio
            </a>
            <a href="#servicios" className="hover:text-white transition-colors" data-id="element-112">
              Servicios
            </a>
            <a href="#precios" className="hover:text-white transition-colors" data-id="element-113">
              Precios
            </a>
            <a href="#contacto" className="hover:text-white transition-colors" data-id="element-114">
              Contacto
            </a>
          </div>

          <button onClick={() => setShowContactModal(true)} className="hidden md:inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-white/5 border border-white/10 text-white font-medium hover:bg-white/10 transition-all duration-300 backdrop-blur-md relative overflow-hidden group" data-id="element-115">
            <span className="relative z-10" data-id="element-116">Contáctanos ahora</span>
            <div className="absolute inset-0 bg-gradient-to-r from-primary/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-117"></div>
          </button>

          {/* Mobile Menu Button */}
          <button onClick={() => setShowMobileMenu(!showMobileMenu)} className="md:hidden w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center hover:bg-white/10 transition-colors" data-id="element-118">
            {showMobileMenu ? <X className="w-5 h-5 text-white" data-id="element-119" /> : <Menu className="w-5 h-5 text-white" data-id="element-120" />}
          </button>
        </div>

        {/* Mobile Menu Dropdown */}
        {showMobileMenu && <div className="md:hidden mt-4 glass-panel rounded-2xl p-4 animate-fadeIn" data-id="element-121">
            <div className="flex flex-col space-y-3" data-id="element-122">
              <a href="#inicio" onClick={() => setShowMobileMenu(false)} className="text-text-secondary hover:text-white transition-colors py-2 px-4 rounded-lg hover:bg-white/5" data-id="element-123">
                Inicio
              </a>
              <a href="#servicios" onClick={() => setShowMobileMenu(false)} className="text-text-secondary hover:text-white transition-colors py-2 px-4 rounded-lg hover:bg-white/5" data-id="element-124">
                Servicios
              </a>
              <a href="#precios" onClick={() => setShowMobileMenu(false)} className="text-text-secondary hover:text-white transition-colors py-2 px-4 rounded-lg hover:bg-white/5" data-id="element-125">
                Precios
              </a>
              <a href="#contacto" onClick={() => setShowMobileMenu(false)} className="text-text-secondary hover:text-white transition-colors py-2 px-4 rounded-lg hover:bg-white/5" data-id="element-126">
                Contacto
              </a>
              <button onClick={() => {
            setShowContactModal(true);
            setShowMobileMenu(false);
          }} className="w-full py-3 px-4 rounded-lg bg-gradient-accent text-background font-medium hover:opacity-90 transition-opacity" data-id="element-127">
                Contáctanos ahora
              </button>
            </div>
          </div>}
      </nav>

      {/* Main Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center mt-12" data-id="element-128">
        {/* Floating Price Badge */}
        <div className="inline-flex items-center justify-center px-4 py-1.5 rounded-full border border-primary/30 bg-primary/10 text-primary text-sm font-medium mb-8 shadow-[0_0_15px_rgba(58,90,255,0.3)] backdrop-blur-sm animate-pulse" data-id="element-129">
          <span className="w-2 h-2 rounded-full bg-primary mr-2" data-id="element-130"></span>
          Desde $150 USD
        </div>

        <h1 className="text-5xl md:text-7xl font-serif font-bold leading-tight mb-6 tracking-tight" data-id="element-131">
          Si tu negocio no existe en internet,
          <br className="hidden md:block" data-id="element-132" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-white via-white to-text-secondary" data-id="element-133">
            tus clientes se los está quedando otro.
          </span>
        </h1>

        <p className="text-xl md:text-2xl text-text-secondary max-w-3xl mx-auto mb-12 leading-relaxed" data-id="element-134">
          Cómo emprendedores están transformando su presencia digital y
          consiguiendo más clientes —{' '}
          <span className="text-white font-medium" data-id="element-135">
            sin gastar una fortuna.
          </span>
        </p>

        {/* Slide to Unlock CTA */}
        <div className="max-w-md mx-auto mb-16" data-id="element-136">
          <div ref={containerRef} onClick={handleUnlock} className={`relative w-full h-16 rounded-full glass-panel flex items-center overflow-hidden transition-all duration-300 cursor-pointer ${isUnlocked ? 'bg-gradient-accent border-transparent' : 'hover:border-white/20'}`} data-id="element-137">
            <div ref={sliderRef} onMouseDown={handleDragStart} onTouchStart={handleDragStart} className={`absolute left-2 w-12 h-12 rounded-full flex items-center justify-center z-10 cursor-grab active:cursor-grabbing ${isUnlocked ? 'bg-white text-black' : 'bg-gradient-accent text-background'}`} style={{
            transform: `translateX(${sliderPosition}px)`,
            transition: isDragging ? 'none' : 'transform 0.3s ease-out'
          }} data-id="element-138">
              {isUnlocked ? <ChevronRight className="w-6 h-6" data-id="element-139" /> : <ArrowRight className="w-6 h-6" data-id="element-140" />}
            </div>
            <span className={`w-full text-center font-medium transition-all duration-300 ${isUnlocked ? 'text-background opacity-0' : 'text-text-secondary pl-8'}`} data-id="element-141">
              Desliza para agendar una cita
            </span>

            {/* Shimmer effect */}
            <div className="absolute inset-0 -translate-x-full animate-[shimmer_2.5s_infinite] bg-gradient-to-r from-transparent via-white/10 to-transparent z-0" data-id="element-142"></div>
          </div>
        </div>

        <div className="max-w-2xl mx-auto text-text-secondary text-sm md:text-base leading-relaxed glass-panel p-6 rounded-2xl" data-id="element-143">
          <p data-id="element-144">
            Ahora mismo, mientras tú estás trabajando duro en tu negocio —
            atendiendo clientes, cuidando cada detalle, dando lo mejor de ti —
            alguien en tu ciudad está buscando exactamente lo que tú ofreces en
            Google.{' '}
            <strong className="text-white font-medium" data-id="element-145">
              Y no te encontró a ti.
            </strong>
          </p>
        </div>
      </div>

      <ContactModal isOpen={showContactModal} onClose={() => setShowContactModal(false)} data-id="element-146" />
    </section>;
}